import { render, staticRenderFns } from "./PremiumMessageSendConfirm.vue?vue&type=template&id=be3f0a92&scoped=true&"
import script from "./PremiumMessageSendConfirm.vue?vue&type=script&lang=js&"
export * from "./PremiumMessageSendConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PremiumMessageSendConfirm.vue?vue&type=style&index=0&id=be3f0a92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3f0a92",
  null
  
)

export default component.exports